import { chassis, standards, vehicleType } from "../../../../data/vehicle";
import { VehicleFeature } from "../../../../interface/transportation";
import { ReactComponent as IconLeftArrow } from "../../../../styles/assets/svg/icon-left-arrow.svg";
import { ReactComponent as IconRightArrow } from "../../../../styles/assets/svg/icon-right-arrow.svg";
import { Button } from "../../../atoms/Buttons";
import { InputSelect } from "../../../atoms/Inputs/InputSelect";
import { CmpInfoCheckBox } from "../CmpInfoCheckBox";
import * as S from "./cmpCarInfoContent.styles";

interface CmpCarInfoContentProps {
  register: any;
  handleSubmit: any;
  onSubmit: (data: any) => void;
  setValue: any;
  watch: any;
  onBackHandler: () => void;
  isButtonTrue: boolean;
}

export const CmpCarInfoContent = ({
  register,
  handleSubmit,
  onSubmit,
  setValue,
  watch,
  onBackHandler,
  isButtonTrue,
}: CmpCarInfoContentProps) => {
  return (
    <S.CmpCarInfoContent onSubmit={handleSubmit(onSubmit)}>
      <S.CmpInfoHeader>
        <S.CmpInfoStep>
          <p>
            <span>3/9단계</span> 운송기사 자격등록
          </p>
        </S.CmpInfoStep>
        <S.CmpCarInfoQuest>
          <span className="colorPrimary">차량정보</span>를 입력해 주세요
        </S.CmpCarInfoQuest>
      </S.CmpInfoHeader>

      <S.CmpCarInfoConentBox>
        <S.CmpCarInfoBox>
          <input
            type="text"
            required
            className="vehicleNumber"
            placeholder="차량번호"
            {...register("vehicleNumber")}
          />

          <InputSelect
            displayExpr="display"
            keyExpr="id"
            placeholder="차종"
            items={vehicleType}
            register={register("vehicleType")}
          />

          <InputSelect
            displayExpr="display"
            keyExpr="id"
            placeholder="규격"
            items={standards}
            register={register("standard")}
          />

          <InputSelect
            displayExpr="display"
            keyExpr="id"
            placeholder="샤시"
            items={chassis}
            register={register("chassis")}
          />
        </S.CmpCarInfoBox>
        <S.CmpCarInfoCheckBox>
          <p>차량 특성</p>
          <S.CmpCarCheckDetail>
            <CmpInfoCheckBox
              label="위험물"
              register={register("vehicleFeatures")}
              value={VehicleFeature.DANGEROUS_GOODS}
              setValue={setValue}
              watch={watch}
            />
            <CmpInfoCheckBox
              label="보세운송"
              register={register("vehicleFeatures")}
              value={VehicleFeature.BOND_MOVEMENT}
              setValue={setValue}
              watch={watch}
            />
            <CmpInfoCheckBox
              label="발전기"
              register={register("vehicleFeatures")}
              value={VehicleFeature.GENERATOR}
              setValue={setValue}
              watch={watch}
            />
            <CmpInfoCheckBox
              label="냉장"
              register={register("vehicleFeatures")}
              value={VehicleFeature.REFRIGERATED}
              setValue={setValue}
              watch={watch}
            />
            <CmpInfoCheckBox
              label="냉동"
              register={register("vehicleFeatures")}
              value={VehicleFeature.FROZEN}
              setValue={setValue}
              watch={watch}
            />
          </S.CmpCarCheckDetail>
        </S.CmpCarInfoCheckBox>
      </S.CmpCarInfoConentBox>
      <S.CmpButtonBox>
        <div className="small">
          <Button
            type="button"
            color="transparent"
            size="full"
            onClick={onBackHandler}
          >
            <IconLeftArrow width={20} height={20} />
            이전
          </Button>
        </div>
        <Button type="submit" size="full" disabled={!isButtonTrue}>
          다음
          <IconRightArrow width={20} height={20} />
        </Button>
      </S.CmpButtonBox>
    </S.CmpCarInfoContent>
  );
};
